import { FC } from 'react';
import { ClaimsComponent } from '@/_shared/components';
import { Claims } from '@/_shared/constants';
import { DialogTrialExpiring } from '@/billing/components/DialogTrialExpiring';
import { getUserAuthorizeCall } from '@/core/state/api/getUserAuthorizeCall';

/**
 * Renders platform warning dialogs based on user roles.
 * Currently displays the trial expiring dialog for Admin users.
 * Suppressed when a blocking error is active.
 */
export const WarningDialogs: FC = () => {
  const { hasBlockingError } = getUserAuthorizeCall.hook();

  if (hasBlockingError) {
    return null;
  }

  return (
    <ClaimsComponent claimKey={Claims.BILLING_WRITE}>
      <DialogTrialExpiring />
    </ClaimsComponent>
  );
};
